import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import Notification from "core/ReusableIcons/Notification";

import colors from "core/colors";

const NotificationsIcon = styled(Notification)`
    position: relative;
    left: 0.4375rem; /* 7px */
    top: 0.25rem; /* 4px */
`;

const HasNotifications = ({ hasNotifications = false }) => (
    <>
        Activity
        {hasNotifications && (
            <NotificationsIcon
                title="Activity Notifications"
                size="md"
                fillColor={colors.darkSkyBlue}
            />
        )}
    </>
);

HasNotifications.propTyes = {
    hasNotifications: PropTypes.bool
};

export default HasNotifications;
